module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }), _c('em', [_vm._v("To Dan, Abigail, Bryce, Carson, DJ, and Nicole —")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("I cherish you.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("You are vibrant proof of God’s great love for me,")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("and on the hard days,")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("your presence reminds me why I breathe.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56c9b7be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ded.vue
// module id = 60
// module chunks = 0